export default __webpack_public_path__ + "static/media/ic-arrow-debit.3663c34a.svg";